import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Card } from '../../shared/components';
import { api } from '../../utils/api';
import './Dashboard.css';

export default function Dashboard() {
  const { user } = useAuth();
  const [progress, setProgress] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    api
      .get('/api/progress')
      .then(setProgress)
      .catch(() => setError('Unable to load your progress right now.'));
  }, []);

  const quizAttempts = progress?.quizzes.byTopic.reduce((sum, t) => sum + Number(t.attempts), 0) || 0;
  const flashcardTotals = progress?.flashcards.byTopic.reduce(
    (acc, t) => ({ known: acc.known + Number(t.known), total: acc.total + Number(t.total) }),
    { known: 0, total: 0 }
  );
  const masteryPct = flashcardTotals?.total ? Math.round((flashcardTotals.known / flashcardTotals.total) * 100) : 0;
  const lastExam = progress?.exams.attempts[0];

  return (
    <div className="dashboard-page">
      <h1>Welcome back{user?.name ? `, ${user.name}` : ''}</h1>
      {error && <p className="dashboard-error">{error}</p>}

      <div className="dashboard-grid">
        <Card className="dashboard-card">
          <h2>Quizzes</h2>
          <p className="dashboard-stat">{quizAttempts}</p>
          <p className="dashboard-label">attempts so far</p>
          <Link to="/quizzes">Practice by domain &rarr;</Link>
        </Card>

        <Card className="dashboard-card">
          <h2>Flashcards</h2>
          <p className="dashboard-stat">{masteryPct}%</p>
          <p className="dashboard-label">terms mastered</p>
          <Link to="/flashcards">Review flashcards &rarr;</Link>
        </Card>

        <Card className="dashboard-card">
          <h2>Practice Exam</h2>
          <p className="dashboard-stat">
            {lastExam ? `${lastExam.correct_count} / ${lastExam.total_questions}` : '—'}
          </p>
          <p className="dashboard-label">{lastExam ? 'last attempt' : 'no attempts yet'}</p>
          <Link to="/exams">Take a timed exam &rarr;</Link>
        </Card>

        <Card className="dashboard-card">
          <h2>Vocabulary</h2>
          <p className="dashboard-stat">{progress?.vocabulary.streak || 0}</p>
          <p className="dashboard-label">day streak</p>
          <Link to="/vocabulary">Today&rsquo;s word &rarr;</Link>
        </Card>
      </div>

      <Link className="dashboard-progress-link" to="/progress">View full progress breakdown &rarr;</Link>
    </div>
  );
}
